// Hand-written (not generated) — mirrors the shape of the generated handlers
// in this directory. Backend contract: ONBOARDING-JOURNEY-SPEC.md §3.
export const onboardingApiHandler = {
  getState: {
    method: 'GET',
    path: () => `onboarding/state`,
  },
  completeStep: {
    method: 'POST',
    path: (payload: { key: string }) =>
      `onboarding/steps/${payload.key}/complete`,
  },
  skipStep: {
    method: 'POST',
    path: (payload: { key: string }) => `onboarding/steps/${payload.key}/skip`,
  },
  // KP-63 JOURNEY steps: auto-enrolls the user in the embedded journey on
  // first call and returns { checklistName, progress: { completedItems,
  // totalItems, fraction, complete } } for display.
  journeyStepState: {
    method: 'GET',
    path: (payload: { key: string }) =>
      `onboarding/steps/${payload.key}/journey`,
  },
};
